//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { UNMODERATED_CONTENT_MODAL_ACTIONS } from '@galleries/constants/galleriesConstants';
import { createAction } from '@utils/actions';

function openModal() {
  return createAction({
    type: UNMODERATED_CONTENT_MODAL_ACTIONS.OPEN_UNMODERATED_CONTENT_MODAL,
  });
}

function closeModal() {
  return createAction({
    type: UNMODERATED_CONTENT_MODAL_ACTIONS.CLOSE_UNMODERATED_CONTENT_MODAL,
  });
}

export type UnmoderatedContentModalActionType = ReturnType<
  typeof openModal | typeof closeModal
>;

export const unmoderatedContentModalActions = {
  openModal,
  closeModal,
};
